<template>
  <a
    href="#"
    class="social-btn cu-btn"
    :style="loginButtonStyles"
    @click.prevent="showCustomFields"
  >
    <i v-show="baseData.flags.loginBtnIcons" class="fa fa-envelope" />
    <span v-text="$t('email')" />
  </a>
</template>

<script>
  import { logUserAction } from '../../utils/logging'

  export default {
    name: 'CustomButton',
    props: ['api', 'action', 'wftkn'],
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      loginButtonStyles() {
        return {
          background: this.loginButtonColor || 'orange',
          color: this.loginButtonTextColor || '#ffffff',
          'justify-content':
            this.baseData.layouts.appLayout === 'app'
              ? 'center'
              : this.loginButtontextAlignment || 'flex-start',
        }
      },
      loginButtontextAlignment() {
        return this.baseData.fonts.alignments.loginBtns
      },
      loginButtonColor() {
        return this.baseData.colors.loginBtns.emailBtn
      },
      loginButtonTextColor() {
        return this.baseData.colors.loginBtns.loginBtnText
      },
    },
    methods: {
      showCustomFields() {
        logUserAction({ type: 'click', label: 'Custom Login Button' })
        this.$eventHub.$emit('showCustom', true)
      },
    },
  }
</script>

<style>
  .cu-btn {
    background: #f7931e;
  }
  .cu-btn:hover {
    background: #cb771a;
  }
</style>
